import { render, staticRenderFns } from "./OfferPastille.vue?vue&type=template&id=045bae6c&name=offer-pastille&"
import script from "./OfferPastille.vue?vue&type=script&lang=js&"
export * from "./OfferPastille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports